import {
  buildVoiceAiCallPayload,
  parseContactPhone,
  type VoiceAiCallPayload,
} from '@/lib/voiceAi/buildVoiceAiCallPayload'

export type ProfileUser = {
  first_name?: string
  last_name?: string
  name?: string
  user_login?: string
  user_email?: string
  email?: string
  default_client_code?: string
  contact_number?: string
  mobile_number?: string
  phone_number?: string
  phone?: string
  user_details?: {
    first_name?: string
    last_name?: string
    user_email?: string
    contact_number?: string
    mobile_number?: string
    phone_number?: string
  }
}

export function getProfileContactPhone(user: ProfileUser | null | undefined): string {
  return String(
    user?.contact_number ??
      user?.mobile_number ??
      user?.phone_number ??
      user?.phone ??
      user?.user_details?.contact_number ??
      user?.user_details?.mobile_number ??
      user?.user_details?.phone_number ??
      ''
  ).trim()
}

export function getProfileContactName(user: ProfileUser | null | undefined): string {
  const firstName = String(user?.first_name ?? '').trim()
  const lastName = String(user?.last_name ?? '').trim()
  const detailsFirstName = String(user?.user_details?.first_name ?? '').trim()
  const detailsLastName = String(user?.user_details?.last_name ?? '').trim()
  return (
    `${firstName} ${lastName}`.trim() ||
    `${detailsFirstName} ${detailsLastName}`.trim() ||
    String(user?.name ?? user?.user_login ?? '').trim()
  )
}

export function getProfileContactEmail(user: ProfileUser | null | undefined): string {
  return String(user?.user_email ?? user?.email ?? user?.user_details?.user_email ?? '').trim()
}

export function hasValidProfilePhone(user: ProfileUser | null | undefined): boolean {
  const raw = getProfileContactPhone(user)
  if (!raw) return false
  const parsed = parseContactPhone(raw)
  return Boolean(parsed?.number?.trim())
}

export function notifyMissingProfilePhone(showError: (error: unknown) => void): void {
  showError('Add a contact number on your Profile before using Call out.')
}

export function buildNewRequestRowFromUser(
  user: ProfileUser | null | undefined
): Record<string, unknown> {
  return {
    contact_name: getProfileContactName(user),
    contact_number: getProfileContactPhone(user),
    contact_email: getProfileContactEmail(user),
    client_code: user?.default_client_code ?? null,
  }
}

export function buildCallOutPayloadFromRow(
  user: ProfileUser | null | undefined,
  row?: Record<string, unknown>
): VoiceAiCallPayload {
  const sourceRow = row ?? buildNewRequestRowFromUser(user)
  const payload = buildVoiceAiCallPayload(sourceRow)
  const defaultClientCode = String(user?.default_client_code ?? '').trim()
  if (!payload.ticket.metadata.clientCode && defaultClientCode) {
    payload.ticket.metadata.clientCode = defaultClientCode
  }
  return payload
}
